import React from 'react';
import { components } from 'react-select';
import classNames from 'classnames';
const MenuComponent = components.Menu;

const Menu = (props) => {
  const {
    selectProps: { size },
  } = props;

  const classes = classNames('ws-ui-base-select-menu', `ws-ui-base-select-menu--${size}`);

  return <MenuComponent className={classes} {...props} />;
};

export default Menu;
